export function getRangeCutoff(range, allDates) {
  if (range === "all" || !allDates.length) return 0;
  const now = new Date(allDates[allDates.length - 1]);
  let cutoff = null;
  switch (range) {
    case "3y":
      cutoff = new Date(now);
      cutoff.setFullYear(now.getFullYear() - 3);
      break;
    case "1y":
      cutoff = new Date(now);
      cutoff.setFullYear(now.getFullYear() - 1);
      break;
    case "6m":
      cutoff = new Date(now);
      cutoff.setMonth(now.getMonth() - 6);
      break;
    case "3m":
      cutoff = new Date(now);
      cutoff.setMonth(now.getMonth() - 3);
      break;
    case "1m":
      cutoff = new Date(now);
      cutoff.setMonth(now.getMonth() - 1);
      break;
    default:
      cutoff = null;
  }
  if (!cutoff) return 0;
  for (let i = 0; i < allDates.length; ++i) {
    if (new Date(allDates[i]) >= cutoff) return i;
  }
  return 0;
} 